import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'core/common/hooks';
import { Offer, UpsellDeprecated } from '../entities';
import {
  selectedOfferUpdated,
  updateSelectedUpsell,
  updateSelectedTrialOffer,
} from '../store/actions';
import {
  getDefaultOffers,
  getDiscountOfferNextPeriod,
  getDiscountOffers,
  getDiscountUpsells,
  getOffersLoadingStatus,
  getSelectedOffer,
  getSelectedTrialOffer,
  getTimeUpOffer,
  getTimeUpOfferSamePeriod,
  getTrialTimeUpOffer,
  getMostExpensiveTimeUpOffer,
  getTimeUpOffers,
  getUpsells,
  getSelectedUpsell,
} from '../store/selectors';

export function useOffers() {
  const dispatch = useDispatch();

  const loadingStatus = useSelector(getOffersLoadingStatus);
  const upsells = useSelector(getUpsells);
  const discountUpsells = useSelector(getDiscountUpsells);
  const defaultOffers = useSelector(getDefaultOffers);
  const timeUpOffers = useSelector(getTimeUpOffers);
  const discountOffers = useSelector(getDiscountOffers);
  const timeUpOffer = useSelector(getTimeUpOffer);
  const timeUpOfferSamePeriod = useSelector(getTimeUpOfferSamePeriod);
  const discountOfferNextPeriod = useSelector(getDiscountOfferNextPeriod);
  const trialTimeUpOffer = useSelector(getTrialTimeUpOffer);
  const mostExpensiveTimeUpOffer = useSelector(getMostExpensiveTimeUpOffer);
  const selectedOffer = useSelector(getSelectedOffer);
  const selectedTrialOffer = useSelector(getSelectedTrialOffer);
  const selectedUpsell = useSelector(getSelectedUpsell);

  const updateTrialOffer = useCallback(
    (offer: Offer) => {
      dispatch(updateSelectedTrialOffer(offer));
    },
    [dispatch],
  );

  const updateOffer = useCallback(
    (offer: Offer) => {
      dispatch(selectedOfferUpdated(offer));
    },
    [dispatch],
  );

  const updateUpsell = useCallback(
    (upsell: UpsellDeprecated) => {
      dispatch(updateSelectedUpsell(upsell));
    },
    [dispatch],
  );

  return {
    upsells,
    discountUpsells,
    defaultOffers,
    timeUpOffers,
    updateTrialOffer,
    updateOffer,
    updateUpsell,
    loadingStatus,
    timeUpOffer,
    timeUpOfferSamePeriod,
    discountOfferNextPeriod,
    trialTimeUpOffer,
    mostExpensiveTimeUpOffer,
    selectedOffer,
    selectedTrialOffer,
    selectedUpsell,
    discountOffers,
  };
}
